import React, { useCallback, useContext } from 'react'
import { InView } from 'react-intersection-observer'
import styled from 'styled-components'
import { rem } from 'polished'
import { useAppSelector } from 'hooks/reduxHooks'
import { selectLoggedIn } from 'selectors/accountSelectors'
import GeoContext from 'contexts/geoContext'
import { useDeferredAnalyticsOptimizely } from 'lib/optimizely/useDeferredAnalyticsOptimizely'
import { OptimizelyExperiments } from 'constants/optimizely'
import TrustIndicatorSection from 'home/components/TrustIndicatorSection/TrustIndicatorSection'

const TRUST_INDICATOR_REGIONS = ['SG', 'MY', 'ZA', 'HK'] as const

const Container = styled.div`
  padding: ${rem(16)} 0;
`

function SearchPageTrustIndicators() {
  const { currentRegionCode } = useContext(GeoContext)
  const isLoggedIn = useAppSelector(selectLoggedIn)

  const { variation, triggerAnalytics } = useDeferredAnalyticsOptimizely(
    OptimizelyExperiments.croTrustIndicatorsSearchPage,
  )

  const isEmergingMarket = TRUST_INDICATOR_REGIONS.includes(
    currentRegionCode as typeof TRUST_INDICATOR_REGIONS[number],
  )

  // Show trust indicators for logged-out users OR users in emerging markets
  const meetsTargetingCriteria = !isLoggedIn || isEmergingMarket

  const isEnabled = !!variation && meetsTargetingCriteria

  const handleInView = useCallback(
    (inView: boolean) => {
      if (inView) {
        triggerAnalytics()
      }
    },
    [triggerAnalytics],
  )

  return (
    <InView onChange={handleInView} triggerOnce>
      {isEnabled && (
        <Container>
          <TrustIndicatorSection />
        </Container>
      )}
    </InView>
  )
}

export default React.memo(SearchPageTrustIndicators)
